import React, { FC, memo } from "../../../lib/teact/teact";
import './myDateInput.scss'
type OwnPops = {
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    label: string;
    labelPosition: 'left' | 'top'
}

const MyDateInput: FC<OwnPops> = ({
    value,
    onChange,
    label,
    labelPosition,
}) => {
    return (
        <div className=" container">
            <label className={" date-input-input-label " + labelPosition}>{label}</label>
            <input id="basic-report-date" type="date" className="my-date-input" value={value}
                pattern="\d{2}/\d{2}/\d{4}" placeholder="dd/mm/yyyy"

                onChange={onChange}
            />
        </div>
    )
}
export default memo(MyDateInput)